<template>
  <div class="go-top">
    <img class="gotop" id="gotop" src="../assets/top.png" alt="" @click="goTop" ref="btn">
  </div>
</template>

<script>
let timer = null
export default {
  data () {
    return {
      isTop: true,
      isBottom: null
    }
  },
  mounted () {
    this.needScroll()
  },
  methods: {
    needScroll () {
      let clientHeight = document.documentElement.clientHeight
      let obtn = this.$refs.btn
      window.onscroll = function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        if (osTop >= clientHeight) {
          obtn.style.display = 'block'
        } else {
          obtn.style.display = 'none'
        }
        if (!this.isTop) {
          clearInterval(timer)
        }
        this.isTop = false
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        if (scrollTop + windowHeight > scrollHeight - 100) {
          document.getElementById('gotop').setAttribute('class', 'bottoming')
        } else {
          document.getElementById('gotop').setAttribute('class', 'gotop')
        }
      }
    },
    goTop () {
      timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    }
  }
}
</script>

<style lang="scss" scoped>
  .go-top{
    width: 100%;
    .gotop{
      position: fixed;
      float: left;
      width: 40px;
      right: 18%;
      bottom: 20px;
    }
  }
  .bottoming {
    position: fixed;
    float: left;
    width: 40px;
    right: 18%;
    bottom: 305px;
  }
  @media only screen and (max-width: 1700px) and (min-width: 0px) {
   .gotop{
      position: fixed;
      width: 40px;
      right: 5% !important;
      bottom: 20px;
    }
    .bottoming {
      position: fixed;
      width: 40px;
      right: 5%;
      bottom: 305px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/XSTop.vue